import { transformComponent } from '../__builtins__/shared'
import { connect, mapProps, mapReadPretty } from '@formily/vue'
import { Slider as VanSlider } from 'vant'
import { defineComponent, h } from 'vue'
import { PreviewText } from '../preview-text'
import { observer } from '@formily/reactive-vue'
import { vantStylePrefix } from '../__builtins__/configs'


const BaseSlider = observer(defineComponent({
  name: 'baseSlider',
  setup(props, {attrs, slots}) {
    return () => {
      return (
        h(VanSlider, {
          class: [`${vantStylePrefix}-slider1`],
          ...props,
          attrs: {
            ...attrs,
          modelValue: attrs.value
          },
        }, {
          slots
        })
      )
    }
  }
}))

export const Slider = connect(
  BaseSlider,
  mapProps({
    readOnly: 'readonly',
    value: 'modelValue',
  }),
  mapReadPretty(PreviewText.Slider)
)
export default Slider